import React from 'react'
import "./About_Key_to_success.css"
import Common_heading from '../../common_component/common_heading/Common_heading'

function About_Key_to_success() {
    return (
        <>
            <section className='About_Key_to_success'>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 mb-5">


                            <div className="list_holder">
                            <Common_heading title="Key to our Success" subTitle="Driven by Vision, Powered by Passion" />
                                <ul>
                                    <li>
                                        Proven track record based on diligence, efficiency and
                                        integrity.
                                    </li>

                                    <li>
                                        Global footprint and on-ground presence in key
                                        markets.
                                    </li>
                                    <li>
                                        Established relationships and large network of
                                        partners.
                                    </li>

                                    <li>
                                        Resilient balance sheet.
                                    </li>

                                    <li>

                                        International management team with extensive market
                                        experience.
                                    </li>

                                    <li>

                                        Strong market position at the intersect of commerce,
                                        trade and finance.
                                    </li>

                                    <li>

                                        Partnerships and affiliations with Government entities.
                                    </li>

                                </ul>
                            </div>
                        </div>

                        <div className="col-md-6 mb-5">


                            <div className="list_holder">
                            <Common_heading title="Our Advantages" subTitle="Driven by Excellence, Powered by Experience" />
                                <ul>
                                    <li>
                                        Proven track record and trusted reputation.

                                    </li>
                                    <li>
                                        Long-standing relationships with suppliers and customers.

                                    </li>
                                    <li>
                                        Extend credit for suppliers and buyers.

                                    </li>
                                    <li>
                                        Effective risk management of currency, credit and price.

                                    </li>
                                    <li>
                                        Lean organisation with experienced team, adept at problem
                                        solving and decision-making.

                                    </li>
                                    <li>
                                        In-depth knowledge of our customers and operational
                                        markets.

                                    </li>
                                    <li>
                                        Global access to products.

                                    </li>
                                    <li>
                                        Long-standing relationships with a wide network of
                                        partners, OEMs and principal vendors.

                                    </li>
                                    <li>
                                        Attractive credit terms & financial solutions

                                    </li>
                                    <li>
                                        Highly skilled team, experienced in global markets

                                    </li>
                                    <li>
                                        Deep knowledge of multiple industries.

                                    </li>
                                    <li>
                                        Expertise in developing bespoke solutions for any situation
                                        or environment.

                                    </li>
                                    <li>

                                        Accomplished in RFQ management.
                                    </li>

                                </ul>
                            </div>
                        </div>

                        <div className="col-md-12 mb-5">


                            <div className="list_holder">
                            <Common_heading title="Supply Chain Solution" subTitle="Delivering the Right Product, at the Right Time, Every Time" />
                                <ul>
                                    <li>
                                        AYANSH INTERNATIONAL TRADING FZ-LLC
                                        provides bespoke Supply Chain Credit Solutions for
                                        corporates. In integration with our commodities and
                                        procurement operations, our credit solutions enable
                                        us to provide comprehensive trade finance solutions
                                        to our customers. Through our experienced financial
                                        trade team, we can tailor Supply Chain Credit
                                        Solutions to our customer’s cash conversion cycle, in
                                        the process mitigating the financial challenges they
                                        may face from the supplier’s payment terms and
                                        strengthening their financial position in the long
                                        term. There are two methods by which customers can
                                        avail our Supply Chain Credit Solutions, one, by
                                        allowing AYANSH INTERNATIONAL TRADING
                                        FZ-LLC to be the supplier or, two, by integrating into
                                        their existing supply chain and allowing us to deal
                                        with their preferred supplier.
                                    </li>


                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default About_Key_to_success